(() => {
  const initDesktop = (nav) => {
    if (nav.dataset.fymReady === "true") return;
    nav.dataset.fymReady = "true";

    const items = [...nav.querySelectorAll("[data-fym-menu-item]")];
    const closeAll = (except) => {
      items.forEach((item) => {
        if (item === except) return;
        item.classList.remove("is-open");
        item.querySelector(".fym-mega-nav__trigger")?.setAttribute("aria-expanded", "false");
      });
    };

    items.forEach((item) => {
      const trigger = item.querySelector(".fym-mega-nav__trigger");
      const panel = item.querySelector("[data-fym-panel]");
      if (!trigger || !panel) return;

      trigger.addEventListener("click", (event) => {
        if (trigger.getAttribute("href") !== "#") return;
        event.preventDefault();
        const opening = !item.classList.contains("is-open");
        closeAll(opening ? item : null);
        item.classList.toggle("is-open", opening);
        trigger.setAttribute("aria-expanded", String(opening));
      });

      item.addEventListener("mouseenter", () => {
        closeAll(item);
        item.classList.add("is-open");
        trigger.setAttribute("aria-expanded", "true");
      });

      item.addEventListener("mouseleave", () => {
        item.classList.remove("is-open");
        trigger.setAttribute("aria-expanded", "false");
      });
    });

    document.addEventListener("click", (event) => {
      if (!nav.contains(event.target)) closeAll();
    });
  };

  const initMobile = (drawer) => {
    if (drawer.dataset.fymReady === "true") return;
    if (drawer.parentElement !== document.body) document.body.appendChild(drawer);
    drawer.dataset.fymReady = "true";

    const openButton = document.querySelector(`[data-fym-mobile-open][aria-controls="${drawer.id}"]`)
      || document.querySelector(".m-header__mobile .m-menu-button");
    const closeButtons = drawer.querySelectorAll("[data-fym-mobile-close]");
    const sheet = drawer.querySelector(".fym-mobile-drawer__sheet");
    const root = drawer.querySelector("[data-fym-mobile-root]");
    const panels = [...drawer.querySelectorAll("[data-fym-mobile-panel]")];
    let returnFocus = null;

    const focusable = () => [...drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')]
      .filter((element) => element.offsetParent !== null);

    const showRoot = () => {
      root?.removeAttribute("aria-hidden");
      panels.forEach((panel) => {
        panel.classList.remove("is-active");
        panel.setAttribute("aria-hidden", "true");
      });
      drawer.querySelectorAll("[data-fym-mobile-target]").forEach((button) => button.setAttribute("aria-expanded", "false"));
    };

    const open = () => {
      returnFocus = document.activeElement;
      showRoot();
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      openButton?.setAttribute("aria-expanded", "true");
      document.body.classList.add("fym-mobile-menu-open");
      sheet?.focus();
    };

    const close = () => {
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      openButton?.setAttribute("aria-expanded", "false");
      document.body.classList.remove("fym-mobile-menu-open");
      document.querySelector(".m-hamburger-box")?.classList.remove("active");
      showRoot();
      (returnFocus || openButton)?.focus();
    };

    drawer.fymOpen = open;
    drawer.fymClose = close;

    openButton?.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      open();
    }, true);

    closeButtons.forEach((button) => button.addEventListener("click", close));

    drawer.querySelectorAll("[data-fym-mobile-target]").forEach((button) => {
      button.addEventListener("click", () => {
        const panel = drawer.querySelector(`#${CSS.escape(button.dataset.fymMobileTarget)}`);
        panels.forEach((item) => {
          const active = item === panel;
          item.classList.toggle("is-active", active);
          item.setAttribute("aria-hidden", String(!active));
        });
        button.setAttribute("aria-expanded", "true");
        root?.setAttribute("aria-hidden", "true");
        if (panel) panel.scrollTop = 0;
        panel?.querySelector("[data-fym-mobile-back]")?.focus();
      });
    });

    drawer.querySelectorAll("[data-fym-mobile-back]").forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        const panel = button.closest("[data-fym-mobile-panel]");
        const target = drawer.querySelector(`[aria-controls="${panel?.id}"]`);
        if (panel) panel.scrollTop = 0;
        showRoot();
        target?.focus();
      });
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && drawer.classList.contains("is-open")) close();
      if (event.key !== "Tab" || !drawer.classList.contains("is-open")) return;
      const items = focusable();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  };

  const init = () => {
    document.querySelectorAll(".fym-mega-nav").forEach(initDesktop);
    document.querySelectorAll("[data-fym-mobile-drawer]").forEach(initMobile);
  };

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
  init();
})();
